exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-26d53d2e]{width:100%}table tr td[data-v-26d53d2e]{vertical-align:top!important}.col-flex[data-v-26d53d2e]{display:-webkit-box;display:-ms-flexbox;display:flex;border:2px solid #000;padding:10px;border-radius:10px}.text-bold[data-v-26d53d2e]{font-weight:700;font-size:90%}.text-right-small[data-v-26d53d2e]{font-size:90%;text-align:right}.small-text[data-v-26d53d2e]{font-size:90%}.vertical-line[data-v-26d53d2e]{width:1px;background-color:#000;margin:0 10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26d53d2e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/receipt-ph/receipt-eft-details.vue
// module id = XI7Z
// module chunks = 113